// NoInternet.jsx
import React from "react";

const NoInternet = () => {
  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        
      }}
    >
      <h1 style={{color:"#E5484D"}}>No Internet Connection</h1>
      <p>Please check your network and try again.</p>
    </div>
  );
};

export default NoInternet;